import suiteService from 'qreventos-suite/services';

class SuiteConfig {
    evento:number = 227;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4SSt4d09sd2VOSjg4WkF5WUZtTS9rTT0=';
    clientId: string = 'aac138f6-1231-41c3-m4c7-a9d798149e2c-227';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  
    }
}

export default new SuiteConfig();